module.exports = __webpack_public_path__ + "img/tlt7-active.7f123b4b.png";